import React from "react";

const RefinementCheckboxList = ({ items, selected, onToggle, limit }) => {
    // Selected items float to the top so the limit never hides an active choice.
    const ordered = limit
        ? [...items]
              .sort(
                  (a, b) =>
                      Number(selected.includes(b.value)) -
                      Number(selected.includes(a.value))
              )
              .slice(0, limit)
        : items;

    return (
    <div className="custom-refinement-list ais-RefinementList">
        {ordered.length === 0 ? (
            <div className="ais-RefinementList-noResults">No results.</div>
        ) : (
            <ul className="ais-RefinementList-list">
                {ordered.map((f) => {
                    const isChecked = selected.includes(f.value);
                    return (
                        <li
                            key={f.value}
                            className={
                                "ais-RefinementList-item" +
                                (isChecked ? " ais-RefinementList-item--selected" : "")
                            }
                        >
                            <label className="ais-RefinementList-label">
                                <input
                                    type="checkbox"
                                    className="ais-RefinementList-checkbox"
                                    checked={isChecked}
                                    onChange={() => onToggle(f.value)}
                                />
                                <span className="ais-RefinementList-labelText">{f.value}</span>
                                <span className="ais-RefinementList-count">{f.count}</span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        )}
    </div>
    );
};

export default RefinementCheckboxList;
